<template>
  <div class="box-content px-3 py-4">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{

  },
  computed:{

  },
  watch:{

  },
  components: {
   
  },
};
</script>

<style>

</style>